import { Inject, Injectable } from '@angular/core';
import { Event, Profile } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { DefaultRessourceStore } from '@shared/services/stores/default-ressource-store.service';

@Injectable()
export class ProfileStore extends DefaultRessourceStore<Profile> {
    constructor(@Inject(getCrudName(Profile)) protected crudService: GenericCrudService<Profile>) {
        super(crudService);
    }

    protected getProjection(): string {
        return 'forProfileDetailForApplication';
    }
}